import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DictionaryAssetDocumentRequestTypes } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'asset-driver-list-view',
  templateUrl: './asset-driver-list-view.component.html',
  styleUrls: ['./asset-driver-list-view.component.scss'],
  standalone: false,
})
export class AssetDriverListViewComponent {
  @Input() public assets: app.models.AssetListModel[] = [];
  @Input() public requestAccessWarnings: string[] = [];
  @Input() public props: app.models.DynamicPropsDictionary;
  @Input() public navigateToDetailHandler: any;
  @Input() public activeContracts: boolean = true;

  constructor(private _router: Router) {}

  redirectDocumentRequest(event: Event, contractId: string, assetId: string) {
    event.stopPropagation();
    this._router.navigate(['requests/new', contractId, assetId]);
  }

  redirectAssetJourney(event: Event, assetId: string) {
    event.stopPropagation();
    this._router.navigate(['asset-driver-list/journey/', assetId], {
      queryParams: { returnUrl: this._router.url.split('?')[0] },
    });
  }

  redirectReportIncident(event: Event, contractId: string, assetId: string) {
    event.stopPropagation();
    this._router.navigate(['requests/new', contractId, assetId, DictionaryAssetDocumentRequestTypes.DAMAGE_DELEGACY]);
  }
}
